import axios from 'axios';
import { get } from 'lodash';
import jwtDecode from 'jwt-decode';
import appConfig from 'config';

const api = axios.create({
  baseURL: appConfig.apiUrl,
});

const defaultStorageKeyName = 'ember_simple_auth-session';
const getStorageValue = () => {
  try {
    const value = localStorage.getItem(defaultStorageKeyName);
    if (value) {
      return JSON.parse(value);
    }
    // eslint-disable-next-line no-empty
  } catch (err) {}
  return {};
};
const setStorageValue = (value) => {
  if (typeof value === 'object') {
    localStorage.setItem(defaultStorageKeyName, JSON.stringify(value));
  } else {
    localStorage.setItem(defaultStorageKeyName, value);
  }
};

const removeStorageValue = () => {
  localStorage.removeItem(defaultStorageKeyName);
};

export default {
  authenticate: async (authenticator, identification, password) => {
    removeStorageValue();
    const { data: token } = await api.post('/apis/v2/account_token', { username: identification, password });
    const tokenData = jwtDecode(token.jwt);
    const isProviderRole = tokenData.role === 'provider';
    const sessionData = getStorageValue();

    if (isProviderRole) {
      setStorageValue({
        ...sessionData,
        providerAttemptedLogin: true,
      });
    } else {
      setStorageValue({
        ...sessionData,
        authenticated: {
          authenticator,
          tokenData,
          ...token,
        },
      });
    }
  },
  invalidate: async () => {
    const sessionData = getStorageValue();
    removeStorageValue();
    const jwt = get(sessionData, 'authenticated.jwt');
    if (jwt) {
      await api.post(
        '/apis/v2/accounts/logout',
        {},
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        },
      );
    }
  },
  isAuthenticated: () => {
    const sessionData = getStorageValue();
    return !!(sessionData?.authenticated && Object.keys(sessionData?.authenticated ?? {}).length > 0);
  },
  jwt: () => {
    const sessionData = getStorageValue();
    return get(sessionData, 'authenticated.jwt');
  },
  data: () => {
    const sessionData = getStorageValue();
    return get(sessionData, 'authenticated.tokenData');
  },
  checkRole: (role) => {
    if (!role) {
      return true;
    }
    const sessionData = getStorageValue();
    const userRole = get(sessionData, 'authenticated.tokenData.role');
    if (!userRole) return false;
    return Array.isArray(role) ? role.includes(userRole) : role === userRole;
  },
  get: (path) => {
    const sessionData = getStorageValue();
    return get(sessionData, path);
  },
  goToProviderPortal: () => {
    removeStorageValue();
    window.location.href = `${window.location.origin}/login`;
  },
};
